import { observer } from 'mobx-react-lite'
import classNames from 'classnames'
import { AttachmentCard } from 'entities/Attachment'
import { MessageCardType, type MessageProps } from 'widgets/MessageCard/ui/types'
import { ConversationMessageCardItem } from 'widgets/MessageCard/ui/ConversationMessageCardItem/ConversationMessageCardItem'
import { DateContent } from 'widgets/MessageCard/ui/DateContent/DateContent'
import { usePresentationModeContext } from 'widgets/PresentationMode'
import styles from './styles.module.scss'

export const VideoContent = observer((props: MessageProps) => {
  const { videos } = props.message
  const presentationStore = usePresentationModeContext()

  const onOpenPresentation = (index: number) => () => {
    presentationStore.setAttachments(videos, index, true)
  }

  if (!videos.length) {
    return <></>
  }

  return (
    <>
      {videos.map((attachment, index) => (
        <ConversationMessageCardItem
          key={attachment.id}
          message={props.message}
          type={MessageCardType.Video}
        >
          <div className={classNames(styles.wrap)}>
            <AttachmentCard
              attachment={attachment}
              medium
              onCardClick={onOpenPresentation(index)}
              onLoad={props.onLoad}
            />
          </div>
          <DateContent {...props} />
        </ConversationMessageCardItem>
      ))}
    </>
  )
})
